<template>
  <div :class="'popover top in editable-container editable-popup ' + hideClass" :style="style">
      <div class="arrow"></div>
      <h3 class="popover-title">{{title}}</h3>
      <div class="popover-content"><div>
        <div class="editableform-loading" style="display: none;"></div>
        <div class="form-group" v-if="errors.length" >
          <ul class="list-group">
            <li class="list-group-item list-group-item-danger" v-for="error in errors" :key="error">{{ error }}</li>
          </ul>
        </div>
        <form class="form-inline editableform" @submit.prevent="submit">
          <div class="control-group form-group">
            <div>
              <div class="editable-input" style="position: relative;">
                <input type="text" class="form-control input-sm" style="padding-right: 24px;" ref="focusItem" v-model="editableItem">
              </div>
              <div class="editable-buttons">
                <button type="submit" class="btn btn-sm editable-submit torre-btn">
                  <i class="material-icons">
                  done
                  </i>
                </button>
                <button type="button" class="btn btn-default btn-sm editable-cancel" @click="closePopup">
                  <i class="material-icons">
                  clear
                  </i>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>

import uns from "underscore.string"
import userService from '@/service/userService'
import productUtils from '@/service/productUtils'
import axios from 'axios'
import appConfig from '@/service/config'
import un from 'underscore'
import priceUtils from "@/utils/PriceUtils"
const numeral = require('numeral')

export default {
  name: "EditableItemPricePopup",
  props: ['title'],
  data: () => ({
    popupStyle: "display: block;",
    editableItem: 0,
    hide: true,
    item: {},
    errors: []
  }),
  created() {
    this.$eventHub.$on('editTableProductPrice', this.onEditTableProductPrice);
    this.$eventHub.$on('paginationClicked', this.onPaginationClicked);
  },
  mounted() {
    this.$refs.focusItem.focus()
  },
  destroyed() {
    this.$eventHub.$off('editTableProductPrice');
    this.$eventHub.$off('paginationClicked');
    document.onkeydown = null
  },
  computed: {
    style() {
      return this.popupStyle
    },
    hideClass() {
      return this.hide ? "hide-popup" : ""
    }
  },
  methods: {
    onPaginationClicked(payload) {
      this.closePopup()
    },
    onEditTableProductPrice(payload) {
      const that = this
      document.onkeydown = function(evt) {
          evt = evt || window.event;
          if (evt.keyCode == 27) {
              that.closePopup();
          }
      };
      this.errors = []
      this.item = payload.product
      const price = payload.product.storeData.price
      const formatedPrice = priceUtils.formatPrice(price)
      this.editableItem = formatedPrice
      this.setPosition(payload.rect)
    },
    setPosition(rect) {
      const top = rect.top + window.scrollY - 100;
      const left = rect.left - ((350 - rect.width) / 2);
      this.popupStyle = "display: block; top:" + top + "px; left: " + left + "px;";
      this.hide = false
      setTimeout(()=> {
        this.$refs.focusItem.focus()
      }, 10)
    },
    closePopup() {
      document.onkeydown = null
      this.hide = true
    },
    submit() {
      this.errors = []
      if (uns.isBlank(this.editableItem)) {
        this.errors.push("Wpisz cenę produktu")
        return false;
      }
      const numbers = this.editableItem.toString()
        .replace(/,/g , "")
        .replace(/\./g , "")
      const onlyNumbers = new RegExp('^[0-9]+$').test(numbers)
      if (!onlyNumbers) {
        this.errors.push("Wpisz poprawną cenę produktu")
        return false;
      }
      var price = numeral(this.editableItem.toString().replace(/,/g , ".")).value();
      const data = {
        newPrice: price,
        productId: this.item.id,
        storeId: userService.getCurrentStore()
      }
      const req = axios({
        method: 'post',
        url: appConfig.baseUrl + '/updateProductPrice',
        data: data,
        headers: {
          Authorization: userService.getAuthHeader()
        }
      })
      req.then(res => {
        const item = productUtils.createProductForNewPrice(this.item, price)
        this.$eventHub.$emit('productPriceUpdated', {
          data: item
        });
        this.closePopup();
      }).catch(err => {
        console.log(err);
        this.errors = un.map(err.response.data.errors, item => {
          return item.defaultMessage
        })
      })

    }
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/utils/EditableItemPricePopup.vue